import { render, staticRenderFns } from "./DeleteProjectForm.vue?vue&type=template&id=36606bb6&scoped=true"
import script from "./DeleteProjectForm.vue?vue&type=script&lang=ts"
export * from "./DeleteProjectForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36606bb6",
  null
  
)

export default component.exports